import React, { useContext } from 'react';
import UserTileContext from '../../../contexts/userTilesContext';
import { IHeaderProps } from '../../../interfaces/interfaces';
import HeaderMenu from '../HeaderMenu/HeaderMenu';

function Header(props: IHeaderProps): JSX.Element {
  const {
    headline,
    tileId,
    isLight,
    hideMenu,
    onToggleEditing,
    isEditing,
    isEditable,
    resizeOptions,
    onResize,
    canCreateNew,
    onCreateNew,
  } = props;

  const userTiles = useContext(UserTileContext);

  // /* eslint-disable no-alert */
  const onRemove = () => {
    userTiles.removeTile(tileId);
  };
  const showMenu = hideMenu ? false : !isLight;

  return (
    <header className={`content-header ${isLight && 'is-light'}`}>
      <h2 className="hl-4 title draggable" dangerouslySetInnerHTML={{ __html: headline || '' }} />
      {showMenu && (
        <HeaderMenu
          onRemove={onRemove}
          onToggleEditing={onToggleEditing}
          isEditing={isEditing}
          isEditable={isEditable}
          resizeOptions={resizeOptions}
          onResize={onResize || undefined}
          canCreateNew={canCreateNew}
          onCreateNew={onCreateNew}
        />
      )}
    </header>
  );
}
export default Header;
